/// <reference path="../typings/index.d.ts" />
declare var chrome: any;
namespace App {
    export class VendaCoins {
        private ajax: IAjax;
        private idExtensao: any = null;
        private contextoSniper: any = null;
        private totalCoins: number = 0;
        private totalCoinsDia: number = 0;
        private totalCoinsMes: number = 0;
        private urlDsFut: string = "https://dsfut.net/api/24/";
        private urlMyDgn: string = "https://api.mydgn.com/";
        private static configDsFut: IConfigFornecedor = null;
        private static configMyDgn: IConfigFornecedor = null;
        private static configContas: IContasConfigTransferenciaCoins[] = [];
        public static itemTransferenciaAtual: IItemTransferenciaCoins = null;
        private static elItemCardTransferencia: JQuery = $("#itemCardTransferencia");
        private elBtTransferirCoins: JQuery = $("#btTransferirCoins");
        private elBtCancelarTransferenciaCoins: JQuery = $("#btCancelarTransferenciaCoins");
        private buttonIniciarProcessoTransferenciasLoading: ILaddaButtonLoading = null;
        private auto: any = null;
        public static contaConfigAtual: IConfigContaTransferenciaCoins = null;
        private buscando: boolean = false;
        private naoTemTransferenciaAtual: boolean = false;
        public static transferindo: boolean = false;
        public static confirmarCompraFormaAutomatica: any;

        public inicializarEventos(idExtensao: any, contextoSniper: any) {
            this.contextoSniper = contextoSniper;
            this.elBtTransferirCoins.on('click', (e) => { this.aoClicarTransferirCoins(e); });
            this.elBtCancelarTransferenciaCoins.on('click', (e) => { this.aoClicarCancelarTransferenciaCoins(e); });
            this.buttonIniciarProcessoTransferenciasLoading = new LaddaButtonLoading();
            this.buttonIniciarProcessoTransferenciasLoading.inicializarCampo("#btnIniciarProcessoTransferencias");
            $("#btnIniciarProcessoTransferencias").on('click', (e) => { this.aoIniciarProcessoDeTransferencia(e); });
            $("#btnCancelarProcessoTransferencias").on('click', (e) => { this.aoPararProcessoDeTransferencia(e); });
            $("#btnJaCompreiCartaMyDGN").on('click', (e) => { this.iniciarConfirmacaoCompraMyDgn(e); });
            $("#btnBuscarInfoItem").on('click', (e) => { this.buscarInformacoesItemVenda(e); });
            $("#abrirTransferenciaConfigConta" + App.SniperExtensao.dadosContaEa.id).on('click', (e) => { this.carregarInformacoesValidacoes(); });

            var modelView = new ModelView();
            modelView.inicializar($(".form-config-fornecedor"), false, null, App.VendaCoins.aposSalvarConfiguracao);
            modelView.inicializar($(".form-transferencias-config-conta"), false, null, App.VendaCoins.aposSalvarConfiguracao);
            this.idExtensao = idExtensao;
            // comentando informações que no momento não estão boas
            //this.getTotalCoins();
            //this.getTotalCoinsDia();
            //this.getTotalCoinsMes();
            this.processarContaAtual();
            this.carregarInformacoesValidacoes();
            $("#btnIniciarProcessoTransferencias").prop('disabled', false);
        }

        private carregarInformacoesValidacoes() {
            if (App.Util.empty(App.VendaCoins.configDsFut)) {
                $("#DsFut" + App.SniperExtensao.dadosContaEa.id).prop('disabled', true);
            } else {
                $("#DsFut" + App.SniperExtensao.dadosContaEa.id).prop('disabled', false);
                $("#areaFormularioConfigConta" + App.SniperExtensao.dadosContaEa.id).show();
                $("#areaPrimeiroConfigureApi" + App.SniperExtensao.dadosContaEa.id).hide();
            }
            if (App.Util.empty(App.VendaCoins.configMyDgn)) {
                $("#MyDGN" + App.SniperExtensao.dadosContaEa.id).prop('disabled', true);
            } else {
                $("#MyDGN" + App.SniperExtensao.dadosContaEa.id).prop('disabled', false);
                $("#areaFormularioConfigConta" + App.SniperExtensao.dadosContaEa.id).show();
                $("#areaPrimeiroConfigureApi" + App.SniperExtensao.dadosContaEa.id).hide();
            }
        }

        private aoIniciarProcessoDeTransferencia(e: JQueryEventObject) {
            this.carregarInformacoesValidacoes();
            if (this.auto == null) {
                this.naoTemTransferenciaAtual = false;
            }
            if (App.Util.empty(App.VendaCoins.configDsFut) && App.Util.empty(App.VendaCoins.configMyDgn)) {
                $("#modal-aviso-configurar-api").modal('show');
                return;
            }
            if (!App.VendaCoins.contaConfigAtual) {
                $("#areaFormularioConfigConta" + App.SniperExtensao.dadosContaEa.id).show();
                $("#areaPrimeiroConfigureApi" + App.SniperExtensao.dadosContaEa.id).hide();
                $("#modalTransferenciaConfigPorConta" + App.SniperExtensao.dadosContaEa.id).modal('show');
                return;
            }
            let idFornecedor = parseInt(App.VendaCoins.contaConfigAtual.id_fornecedor_ativo as any);
            this.iniciarProcessoVendaCoins(idFornecedor);
        }

        private iniciarProcessoVendaCoins(idFornecedor: number) {
            if (this.buscando) {
                console.log("ainda buscando");
                return;
            }

            this.buscando = true;
            this.buttonIniciarProcessoTransferenciasLoading.exibirLoading();
            this.getItemAVenda(idFornecedor);
            if (this.auto == null) {
                App.SniperExtensao.arrayLoopIntervalos.push(this.auto = setInterval(() => {
                    if (this.buscando || $("#btTransferirCoins").is(":visible")) {
                        if ($("#btTransferirCoins").is(":visible")) {
                            this.buscando = false;
                            clearInterval(this.auto);
                            this.auto = null;
                        }
                        return;
                    }
                    $("#btnIniciarProcessoTransferencias").click();
                    if ($("#btTransferirCoins").is(":visible")) {
                        clearInterval(this.auto);
                        this.auto = null;
                    }
                }, idFornecedor == Util.ID_FORNECEDOR_DSFUT ? App.VendaCoins.configDsFut.frequencia_busca_milissegundos : App.VendaCoins.configMyDgn.frequencia_busca_milissegundos));
            }
        }

        private getItemAVenda(idFornecedor: number) {
            App.SniperExtensao.exibirLoadingSniperApp();
            this.getItemTransferenciaAtual((itemTransferencia: any) => {
                if (App.Util.empty(itemTransferencia)) {
                    this.naoTemTransferenciaAtual = true;
                    if (idFornecedor == Util.ID_FORNECEDOR_DSFUT) {
                        this.getItemTransferenciaDsFut();
                    }
                    if (idFornecedor == Util.ID_FORNECEDOR_MYDGN) {
                        this.getItemTranferenciaMyDgn();
                    }
                } else {
                    App.SniperExtensao.runAudio(6);
                    App.VendaCoins.itemTransferenciaAtual = itemTransferencia.dados;
                    App.VendaCoins.exibirItemTransferencia(itemTransferencia);
                    App.SniperExtensao.ocultarLoadingSniperApp();
                    this.buttonIniciarProcessoTransferenciasLoading.ocultarLoading('BUSCAR');
                    // this.buscarInformacoesItemVenda(itemTransferencia);
                    if (idFornecedor == Util.ID_FORNECEDOR_DSFUT) {
                        this.processarCompraAutomatica(null);
                    }
                    if (idFornecedor == Util.ID_FORNECEDOR_MYDGN) {
                        this.processarCompraAutomatica(itemTransferencia.dados.transactionID);
                    }
                }
            });
        }

        private aoPararProcessoDeTransferencia(e: JQueryEventObject) {
            App.SniperExtensao.finalizarLoopIntervalo();
            clearInterval(this.auto);
            this.auto = null;
            this.buscando = false;
            App.VendaCoins.transferindo = false;
            this.buttonIniciarProcessoTransferenciasLoading.ocultarLoading('BUSCAR');
            App.SniperExtensao.ocultarLoadingSniperApp();
        }

        public static aposSalvarConfiguracao(dados: any) {
            if (dados.dadosRetornados.dadosResposta.hasOwnProperty('configuracao')) {
                App.VendaCoins.configContas = App.Util.updateOrCreateItemArrayById(App.VendaCoins.configContas, dados.dadosRetornados.dadosResposta.id_conta_ea, { id: dados.dadosRetornados.dadosResposta.id_conta_ea, configuracao: dados.dadosRetornados.dadosResposta.configuracao })
                let objcontaConfig: IContasConfigTransferenciaCoins = App.Util.getItemArrayById(App.VendaCoins.configContas, App.SniperExtensao.dadosContaEa.id);
                App.VendaCoins.contaConfigAtual = objcontaConfig ? objcontaConfig.configuracao : null;
            } else {
                if (dados.dadosRetornados.dadosResposta.id_fornecedor == Util.ID_FORNECEDOR_MYDGN) {
                    App.VendaCoins.configMyDgn = dados.dadosRetornados.dadosResposta;
                } else {
                    App.VendaCoins.configDsFut = dados.dadosRetornados.dadosResposta;
                }
            }
        }

        public static setConfigs(configDsFut: string, configMyDgn: string) {
            App.VendaCoins.configDsFut = configDsFut ? JSON.parse(configDsFut) : null;
            App.VendaCoins.configMyDgn = configMyDgn ? JSON.parse(configMyDgn) : null;
        }
        public static setConfigContas(id: number, configConta: string) {
            App.VendaCoins.configContas.push({ id: id, configuracao: JSON.parse(configConta) });
        }

        private getTotalCoins() {
            if (this.totalCoins) {
                return this.totalCoins;
            }
            this.totalCoins = parseInt(App.Util.obterSomenteNumerosDaString($('#infoCoins').html()));
            return this.totalCoins;
        }

        private getTotalCoinsDia() {
            if (this.totalCoinsDia) {
                return this.totalCoinsDia;
            }
            this.totalCoinsDia = parseInt(App.Util.obterSomenteNumerosDaString($('#totalCoinsDia').html()));
            return this.totalCoinsDia;
        }

        private getTotalCoinsMes() {
            if (this.totalCoinsMes) {
                return this.totalCoinsMes;
            }
            this.totalCoinsMes = parseInt(App.Util.obterSomenteNumerosDaString($('#totalCoinsMes').html()));
            return this.totalCoinsMes;
        }

        private atualizarTotalCoinsGeralView() {
            $('#infoCoins').html(this.totalCoins.toLocaleString('pt-BR'));
        }
        private atualizarTotalCoinsDiaView() {
            $('#totalCoinsDia').html(this.totalCoinsDia.toLocaleString('pt-BR'));
        }
        private atualizarTotalCoinsMesView() {
            $('#totalCoinsMes').html(this.totalCoinsMes.toLocaleString('pt-BR'));
        }

        private incrementarTotalCoinsMes(coinsAdd: number) {
            this.totalCoinsMes += coinsAdd;
            this.atualizarTotalCoinsMesView();
        }
        private incrementarTotalCoinsDia(coinsAdd: number) {
            this.totalCoinsDia += coinsAdd;
            this.atualizarTotalCoinsDiaView();
        }
        public incrementarTotalCoins(coinsAdd: number) {
            this.incrementarTotalCoinsMes(coinsAdd);
            this.incrementarTotalCoinsDia(coinsAdd);
        }
        public decrementarTotalCoinsGeral(coinsSub: number) {
            this.getTotalCoins();
            this.totalCoins -= coinsSub;
            this.atualizarTotalCoinsGeralView();
        }

        public ordenarContaAtivaPrimeiro() {
            var listaContas: JQuery = $(".scrollbar.scrollbar-default .list-group.list-group-flush");
            var contaAtiva: JQuery = $(".checklist-item.checklist-item-success");
            var linhaContaAtiva = contaAtiva.parent();
            contaAtiva.parent().remove();
            listaContas.prepend(linhaContaAtiva);
        }

        private processarContaAtual() {
            App.SniperExtensao.webAppVisivel = true;
            if (App.SniperExtensao.dadosContaEa) {
                $('#conta' + App.SniperExtensao.dadosContaEa.id).find('.info-atual').show();
                $('#conta' + App.SniperExtensao.dadosContaEa.id).find('#abrirTransferenciaConfigConta' + App.SniperExtensao.dadosContaEa.id).show();
                let objcontaConfig: IContasConfigTransferenciaCoins = App.Util.getItemArrayById(App.VendaCoins.configContas, App.SniperExtensao.dadosContaEa.id);
                App.VendaCoins.contaConfigAtual = objcontaConfig ? objcontaConfig.configuracao : null;
                console.log("contaConfigAtual", App.VendaCoins.contaConfigAtual);
            }
        }

        public buscarInformacoesItemVenda(e: JQueryEventObject) {
            console.log("debug filtro:", this.contextoSniper.getObjetoFiltroTransferenciaCoins(App.VendaCoins.itemTransferenciaAtual));
            chrome.runtime.sendMessage(this.idExtensao, {
                evento: "getInfoItem",
                filtro: this.contextoSniper.getObjetoFiltroTransferenciaCoins(App.VendaCoins.itemTransferenciaAtual),
                id: App.VendaCoins.itemTransferenciaAtual.tradeID
            },
                (resposta: any) => { });
        }

        public processarCompraAutomatica(idTransacaoMydgn: number = null) {
            try {
                this.buscando = false;
                if (App.VendaCoins.contaConfigAtual && App.VendaCoins.contaConfigAtual.comprar_automaticamente) {
                    $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogComprarAuto());
                    setTimeout(() => {
                        this.aoClicarTransferirCoins(null);
                    }, 4000);
                    if (App.VendaCoins.contaConfigAtual.id_fornecedor_ativo == Util.ID_FORNECEDOR_MYDGN) {
                        this.checkStatusMyDgn(idTransacaoMydgn, App.VendaCoins.configMyDgn.email);
                    }
                } else {
                    console.log("não comprar automaticamente");
                }
            } catch (e) {
                this.buscando = false;
                $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogComprarAutoFalhou(e));
            }
        }

        private getItemTransferenciaAtual(metodoCallback: any) {
            if (this.naoTemTransferenciaAtual) {
                metodoCallback(null);
                return;
            }
            this.ajax = new Ajax();
            this.ajax.get(App.Util.config.urlObterItemTransferenciaCoins, { id_conta: App.SniperExtensao.dadosContaEa.id }, (dadosSucesso: IRespostaSucessoAjx) => {
                metodoCallback(dadosSucesso.dadosRetornados);
            }, (dadosErro: IRespostaErroAjx) => {
                metodoCallback(null);
            }, null, false);
        }

        private getQuantidadeAtualTransferenciasDia(metodoCallback: any) {
            this.ajax = new Ajax();
            this.ajax.get(App.Util.config.urlObterItemTransferenciaCoins, { quantidade_dia: true, id_conta: App.SniperExtensao.dadosContaEa.id }, (dadosSucesso: IRespostaSucessoAjx) => {
                metodoCallback(dadosSucesso.dadosRetornados);
            }, (dadosErro: IRespostaErroAjx) => {
                metodoCallback(null);
            }, null, false);
        }

        private getPlataformaVendaCoins(plataforma: string){
          switch (plataforma) {
            case "pc":
            case "PC":
              return "pc"
            default:
              return "cons";
          }

        }

        private getItemTranferenciaMyDgn() {
            let user: string = App.VendaCoins.configMyDgn.id_usuario_fornecedor;
            let secretKey: string = App.VendaCoins.configMyDgn.token;
            let plataforma: string = this.getPlataformaVendaCoins(App.SniperExtensao.dadosContaEa.ptf.toString());
            let timestamp: string = Math.round((new Date()).getTime() / 1000).toString();
            let hash = MD5(plataforma.toString() + user.toString() + timestamp.toString() + secretKey.toString());
            let filtroMyDgn: IFiltroMyDgn = {};
            if (App.VendaCoins.configMyDgn.valor_minimo && App.VendaCoins.configMyDgn.valor_minimo != 0) {
                filtroMyDgn.min_buy = App.VendaCoins.configMyDgn.valor_minimo;
            } else {
                filtroMyDgn.min_buy = 0;
            }

            if (App.VendaCoins.configMyDgn.valor_maximo && App.VendaCoins.configMyDgn.valor_maximo != 0) {
                filtroMyDgn.max_buy = App.VendaCoins.configMyDgn.valor_maximo;
            } else {
                filtroMyDgn.max_buy = 1000000;
            }
            let urlResourcesMyDgn = '?user=' + user + "&platform=" + plataforma + "&timestamp=" + timestamp + "&hash=" + hash + "&maximumBuyOutPrice=" + filtroMyDgn.max_buy + "&minimumBuyOutPrice=" + filtroMyDgn.min_buy + "&botapp=futsniperweb";
            let url = this.urlMyDgn + 'transfers' + urlResourcesMyDgn;
            chrome.runtime.sendMessage(this.idExtensao, { evento: "getmydgn", url: url, filtro: filtroMyDgn },
                (resposta: any) => {
                    this.tratarRespostaFornecedorMyDgn(resposta);
                });

        }

        public iniciarConfirmacaoCompraMyDgn(e: JQueryEventObject) {
            this.checkStatusMyDgn(App.VendaCoins.itemTransferenciaAtual.transactionID, App.VendaCoins.configMyDgn.email);
        }

        private checkStatusMyDgn(transactionID: number, email: string = '', status: string = 'bought') {
            let user: string = App.VendaCoins.configMyDgn.id_usuario_fornecedor;
            let plataforma: string = this.getPlataformaVendaCoins(App.SniperExtensao.dadosContaEa.ptf.toString());
            let timestamp: string = Math.round((new Date()).getTime() / 1000).toString();
            let secretKey: string = App.VendaCoins.configMyDgn.token;

            let dadosRequestStatusMyDgn: IStatusMyDgn = {
                user: user,
                platform: plataforma,
                timestamp: timestamp,
                hash: MD5(plataforma.toString() + user.toString() + timestamp.toString() + secretKey.toString()),
                emailHash: MD5(email),
                transactionID: transactionID,
                status: status, //bought | cancel
            }
            let url = this.urlMyDgn + 'status';
            chrome.runtime.sendMessage(this.idExtensao, { evento: "checkstatusmydgn", url: url, dados: dadosRequestStatusMyDgn },
                (resposta: any) => {
                    if (!App.VendaCoins.contaConfigAtual.comprar_automaticamente) {
                        if (dadosRequestStatusMyDgn.status == 'bought') {
                            if (resposta.status) {
                                $("#espacoLogs").find('.confirmacao-compra').remove();
                                this.exibirLogConfirmacaoCompraMyDgn('success', 'Sua confirmação de compra foi enviado com sucesso');
                                $("#modalItemDetalhes").modal("hide");
                                $(".item-transferencia").hide();
                                //AQUI ESTÁ ATUALIZANDO O STATUS DA COMPRA
                                let btnCurrentTransferencia = $("#itemCardTransferencia").find('button.btn-transferir-coins');
                                this.ajax.postAcaoSemCabecalhoGlobal(btnCurrentTransferencia.data("url"), { id: btnCurrentTransferencia.data("id") });
                            } else {
                                $("#espacoLogs").find('.confirmacao-compra').remove();
                                this.exibirLogConfirmacaoCompraMyDgn('danger', 'Falha na confirmação da sua compra, talvez o tempo de envio tenha esgotado');
                            }
                        }
                    }
                });
        }

        private getItemTransferenciaDsFut() {
            let plataforma: string = this.getSimboloPlataformaDsFut(App.SniperExtensao.dadosContaEa.ptf.toString());
            let timestamp: string = null;
            let signature = MD5(App.VendaCoins.configDsFut.id_usuario_fornecedor.toString() + App.VendaCoins.configDsFut.token.toString() + (timestamp = Math.round((new Date()).getTime() / 1000).toString()));
            let urlResourcesDsfut = plataforma + "/" + App.VendaCoins.configDsFut.id_usuario_fornecedor.toString() + "/" + timestamp + "/" + signature;
            let url = this.urlDsFut + urlResourcesDsfut;

            let filtroDsFut: IFiltroDsfut = {};

            if (App.VendaCoins.configDsFut.valor_minimo && App.VendaCoins.configDsFut.valor_minimo != 0) {
                filtroDsFut.min_buy = App.VendaCoins.configDsFut.valor_minimo;
            }

            if (App.VendaCoins.configDsFut.valor_maximo && App.VendaCoins.configDsFut.valor_maximo != 0) {
                filtroDsFut.max_buy = App.VendaCoins.configDsFut.valor_maximo;
            }

            if (App.VendaCoins.configDsFut.minimo_segundos && App.VendaCoins.configDsFut.minimo_segundos != 0) {
                filtroDsFut.take_after = App.VendaCoins.configDsFut.minimo_segundos;
            }
            chrome.runtime.sendMessage(this.idExtensao, { evento: "getdsft", url: url, filtro: filtroDsFut },
                (resposta: any) => {
                    this.tratarRespostaFornecedorDsFut(resposta.item);
                });
        }

        private tratarRespostaFornecedorDsFut(item: any) {
            console.log('tratarRespostaFornecedorDsFut', item);
            switch (true) {
                case !item:
                case item.error == 'empty':
                    $("#espacoLogs").find('.item-nao-encontrado').remove();
                    $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogItemNaoEncontrado());
                    this.buscando = false;
                    break;
                case item.error == 'sign':
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut("Seus dados de acesso a API DsFut estão incorretos, favor verificar e tentar novamente.");
                    this.buscando = false;
                    break;
                case item.error == 'block':
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut(item.message);
                    this.buscando = false;
                    break;
                case item.error == 'limit':
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut("O limite de jogadores resgatados foi excedido. É permitido ter no máximo 3 jogadores ativos");
                    this.buscando = false;
                    break;
                case !App.Util.empty(item.error):
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut(item.message);
                    this.buscando = false;
                    break;
                default:
                    App.SniperExtensao.ocultarLoadingSniperApp();
                    this.buttonIniciarProcessoTransferenciasLoading.ocultarLoading('BUSCAR');
                    $("#espacoLogs").find('.item-nao-encontrado').remove();
                    App.SniperExtensao.runAudio(6);
                    var dados = null;
                    dados = {
                        trade_id: item.player.tradeID,
                        coins: item.player.buyNowPrice,
                        dados: item.player,
                        id_conta: App.SniperExtensao.dadosContaEa.id,
                        id_fornecedor: Util.ID_FORNECEDOR_DSFUT,
                    };
                    this.ajax = new App.Ajax();
                    this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlSalvarItemTransferenciaCoins, dados, App.VendaCoins.aoSalvarNovoItemTransferencia, this);
                    break;
            }

        }

        private tratarRespostaFornecedorMyDgn(dados: any) {
            console.log('tratarRespostaFornecedorMyDgn::', dados);
            switch (true) {
                case dados.hasOwnProperty('error') && dados.error.status == 404:
                    $("#espacoLogs").find('.item-nao-encontrado').remove();
                    $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogItemNaoEncontrado());
                    this.buscando = false;
                    break;
                case dados.hasOwnProperty('error') && (dados.error.status == 400 || dados.error.status == 401):
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut("Seus dados de acesso a API MyDgn estão incorretos, favor verificar e tentar novamente.");
                    this.buscando = false;
                    break;
                case dados.hasOwnProperty('error') && dados.error.status == 429:
                    this.aoPararProcessoDeTransferencia(null);
                    this.exibirLogErroFornecedorDsfut("Várias requisições foram feitas na API, por favor espere alguns minutos para tentar novamente.");
                    this.buscando = false;
                    break;
                default:
                    App.SniperExtensao.ocultarLoadingSniperApp();
                    this.buttonIniciarProcessoTransferenciasLoading.ocultarLoading('BUSCAR');
                    $("#espacoLogs").find('.item-nao-encontrado').remove();
                    App.SniperExtensao.runAudio(6);
                    var dadosObj = null;
                    dadosObj = {
                        trade_id: dados.item.tradeID,
                        coins: dados.item.coinAmount,
                        dados: dados.item,
                        id_conta: App.SniperExtensao.dadosContaEa.id,
                        id_fornecedor: Util.ID_FORNECEDOR_MYDGN,
                        valor_comissao_fornecedor: dados.item.paymentInUsd,
                    };
                    this.ajax = new App.Ajax();
                    this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlSalvarItemTransferenciaCoins, dadosObj, App.VendaCoins.aoSalvarNovoItemTransferencia, this);
                    break;
            }

        }
        private getSimboloPlataformaDsFut(ptf: string) {
            switch (ptf) {
                case "psn":
                case "PSN":
                case "PS4":
                case "ps4":
                    return "ps"
                case "xbox":
                case "xbo":
                case "XBL":
                case "xbl":
                    return "xb"
                case "pc":
                    return "pc"
            }
        }

        public static aoSalvarNovoItemTransferencia(resposta: IRespostaSucessoAjx) {
            App.VendaCoins.itemTransferenciaAtual = resposta.dadosRetornados.dados;
            App.VendaCoins.exibirItemTransferencia(resposta.dadosRetornados);
            let vendacoins: any = resposta.parametroCallback;
            var id_transacao_mydgn = resposta.dadosEnviados.dados.transactionID;
            vendacoins.processarCompraAutomatica(id_transacao_mydgn);
        }

        private static exibirItemTransferencia(obj: any) {
            App.VendaCoins.elItemCardTransferencia.show();
            var nomeJogador = null;
            var rating = null;
            var buyNowPrice = null;
            var idJogador = null;
            var urlImagemJogador = "/fut21/Images";
            var urlImagemResource = "/Players/";

            if (obj.dados.hasOwnProperty('playerName')) {
                var itemMydgn: IItemTransferenciaCoinsMyDgn = obj.dados;

                nomeJogador = itemMydgn.playerName;
                idJogador = itemMydgn.assetID;
                rating = itemMydgn.rating.toString();
                buyNowPrice = itemMydgn.coinAmount.toString()
                App.VendaCoins.elItemCardTransferencia.find('.card-body').css({ opacity: 10 });
                App.VendaCoins.elItemCardTransferencia.find('.carimbo').hide();
                App.VendaCoins.elItemCardTransferencia.find('.desc-especial').html(itemMydgn.rating_search != itemMydgn.rating ? 'Especial' : 'Comum');
                App.VendaCoins.elItemCardTransferencia.find('.preco-min').html(itemMydgn.startPrice.toString());
                App.VendaCoins.elItemCardTransferencia.find('.posicao').html("");
                App.VendaCoins.elItemCardTransferencia.find('.info-tempo').html("");
                urlImagemJogador += '/Players/0.png';
            } else {
                var item: IItemTransferenciaCoins = obj.dados;
                var player = App.Util.getItemArrayById(App.SniperExtensao.players, item.assetID);
                nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
                idJogador = item.assetID;
                rating = item.rating.toString();
                buyNowPrice = item.buyNowPrice.toString();
                App.VendaCoins.elItemCardTransferencia.find('.card-body').css({ opacity: 10 });
                App.VendaCoins.elItemCardTransferencia.find('.carimbo').hide();
                App.VendaCoins.elItemCardTransferencia.find('.desc-especial').html(item.assetID != item.resourceID ? 'Especial' : 'Comum');
                App.VendaCoins.elItemCardTransferencia.find('.preco-min').html(item.startPrice.toString());
                App.VendaCoins.elItemCardTransferencia.find('.posicao').html(item.position);
                App.VendaCoins.elItemCardTransferencia.find('.info-tempo').html(obj.minutos + " min");
                if (player.hasOwnProperty('moment')) {
                    urlImagemResource = "/playerheads/mobile/single/p";
                }
                urlImagemJogador += urlImagemResource + idJogador + '.png';
            }
            App.VendaCoins.elItemCardTransferencia.find('.nome-item').html(nomeJogador);
            App.VendaCoins.elItemCardTransferencia.find('.overal').html(rating);
            App.VendaCoins.elItemCardTransferencia.find('.coins-transferencia').html(buyNowPrice);
            App.VendaCoins.elItemCardTransferencia.find('.btn-cancelar-transferencia-coins').attr('data-id', obj.id).data('id', obj.id);
            App.VendaCoins.elItemCardTransferencia.find('.btn-transferir-coins').attr('data-id', obj.id).data('id', obj.id);
            App.VendaCoins.elItemCardTransferencia.find('.avatar').attr('src', urlImagemJogador);

            $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogItemRecebido(nomeJogador, rating, buyNowPrice));
        }

        public static getConteudoLogItemRecebido(nomeItem: string, overal: string, coins: string): string {
            return '<span class="badge badge-pill badge-primary text-uppercase">Item Recebido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Item ' + nomeItem + '(' + overal + ') recebido para transferência de ' + coins + ' coins</p>';
        }
        public static getConteudoLogComprarAuto(): string {
            return '<span class="badge badge-pill badge-primary text-uppercase">Compra Automática</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Iniciado a compra automática</p>';
        }
        public static getConteudoLogComprarAutoFalhou(e: any): string {
            return '<span class="badge badge-pill badge-danger text-uppercase">Falha na Compra Automática</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Compra automática falhou</p>';
        }
        public static getConteudoLogItemNaoEncontrado(): string {
            return '<div class="item-nao-encontrado"><span class="badge badge-pill badge-warning text-uppercase">Não encontrado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Item não encontrado</p></div>';
        }
        public static getConteudoLogItemExpirado(): string {
            return '<span class="badge badge-pill badge-warning text-uppercase">Tempo Expirado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">A compra demorou muito para ser feita e o item expirou</p>';
        }
        public getConteudoLogTransferenciaConcluida(item: any): string {
            return '<span class="badge badge-pill badge-success text-uppercase">Transferido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Concluída a transferência de ' + item.coinAmount ? item.coinAmount : item.buyNowPrice + ' coins</p>';
        }
        public static getConteudoLogTransferenciaCancelada(): string {
            return '<span class="badge badge-pill badge-warning text-uppercase">Cancelada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Sua transferência de coins foi cancelada</p>';
        }

        private exibirLogConfirmacaoCompraMyDgn(tipo: string, msg: string) {
            $("#espacoLogs").prepend(`<div class="confirmacao-compra"><span class="badge badge-pill badge-${tipo} text-uppercase">confirmação de compra</span><span class="text-muted pull-right mt-1 font-size-10"> ${new Date().toLocaleString()} </span><p class="description border-bottom"> ${msg} </p></div>`);
        }

        private exibirLogErroFornecedorDsfut(msg: string) {
            $("#espacoLogs").prepend('<span class="badge badge-pill badge-warning text-uppercase">Problema</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">' + msg + '</p>');
        }

        private aoClicarTransferirCoins(e: JQueryEventObject) {
            if (App.VendaCoins.transferindo) {
                return;
            }

            // if (!App.SniperExtensao.webAppVisivel) {
            //     App.SniperExtensao.runAudio(5);
            //     this.contextoSniper.exibirLog("danger danger-webapp-minimizado", "WebApp Minimizado", "Deixe a tela do seu WebApp <b>visível em primeiro plano</b> para o sistema fazer a compra da carta", "log-webapp-minimizado");
            //     return;
            // }

            App.VendaCoins.transferindo = true;
            this.getQuantidadeAtualTransferenciasDia((resposta: any) => {
                console.log("contaConfigAtual", App.VendaCoins.contaConfigAtual);
                if (App.VendaCoins.contaConfigAtual && resposta && resposta.hasOwnProperty("quantidade") && resposta.quantidade < App.VendaCoins.contaConfigAtual.quantidade_max_transferencia_dia) {
                    this.contextoSniper.comprarItemTransferindoCoins(App.VendaCoins.itemTransferenciaAtual, (resultado: any) => { });
                } else {
                    App.VendaCoins.transferindo = false;
                    App.SniperExtensao.runAudio(5);
                    this.contextoSniper.exibirLog("warning", "Limite Atingido", "Você atingiu o limite de transferência de coins configurado em sua conta", "limite-transferencia");
                }
            });
        }

        private aoClicarCancelarTransferenciaCoins(e: JQueryEventObject) {
            this.ajax = new App.Ajax();
            let dados: any = { id: $(e.currentTarget).data("id") };
            this.checkStatusMyDgn(App.VendaCoins.itemTransferenciaAtual.transactionID, App.VendaCoins.configMyDgn.email, 'cancel');
            this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"), dados, (resposta: IRespostaSucessoAjx) => {
                let el = resposta.parametroCallback;
                $(el.currentTarget).parents(".item-transferencia").hide();
                $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogTransferenciaCancelada());

                var seletorMinuto = document.querySelector(".minuto");
                var seletorSegundo = document.querySelector(".segundo");
                if (seletorMinuto && seletorSegundo) {
                    seletorMinuto.textContent = "3";
                    seletorSegundo.textContent = "00";
                }
                this.enviarConfirmacaoCompraSemAcaoUsuarioMyDgn(false);
            }, e);
        }
        public addCarimboItemComprado(e: JQuery) {
            let itemView = e.parents(".item-transferencia")
            itemView.find('.card-body').css({ opacity: 0.1 });
            itemView.find('.carimbo').show();
            setTimeout(() => {
                itemView.hide();
            }, 18000);
        }

        public enviarConfirmacaoCompraSemAcaoUsuarioMyDgn(confirmar = true) {
            if (confirmar) {
                App.VendaCoins.confirmarCompraFormaAutomatica = setTimeout(() => {
                    this.iniciarConfirmacaoCompraMyDgn(null);
                }, 179000);
            } else {
                clearTimeout(App.VendaCoins.confirmarCompraFormaAutomatica);
            }
        }

    }
}
